import React from 'react';
import '../styles/suspensionNoticeModal.css';

export const SuspensionNoticeModal = ({ onClose }) => {
    return (
        <div className='suspensionNoticeModal_container'>
            <div className='suspensionNoticeModal_subContainer'>
                <button className='suspensionNoticeModal_cerrar' onClick={onClose}>X</button>
                <h3>Aviso de suspensión de servicio</h3>
                <p>
                    Le informamos que actualmente su cuenta presenta un saldo pendiente de pago.
                    De no regularizarse el adeudo dentro de las 48 horas posteriores a este primer
                    aviso, procederemos con la suspensión temporal del servicio. Le agradecemos
                    realizar su pago a la brevedad para evitar cualquier interrupción y garantizar
                    la continuidad de su servicio.
                </p>
            </div>
        </div>
    );
};
